import TransferEditWorkspace from '../features/transfers/layouts/edit-workspace';

// TSS vite/01 §"Pages are thin". Reanudar una sesión TE (pestaña propia), abierta
// desde la landing de transferencia de una OPU. Gated en app.jsx.
export default function TransferEditPage() {
    return <TransferEditWorkspace />;
}
